import type {FC} from 'react'
import {ButtonV2} from 'src/common/ButtonV2'
import {Icon} from 'src/common/Icon'
import type {UrlObject} from 'url'

interface CTAButtonWithArrowProps {
  label: string
  href: string | UrlObject
  trackingData: {
    mktgId: string
    location: string
    dataType: string
    pageName: string
    label: string
  }
  id: string
  className?: string
}

export const CTAButtonWithArrow: FC<CTAButtonWithArrowProps> = ({label, href, trackingData, id, className = ''}) => (
  <ButtonV2
    variant="primary"
    href={href}
    trackingData={trackingData}
    newTrackingProps={{
      interaction: {
        element: `stresstimonials-floating-cta-button`,
        elementText: label || '',
        location: `stresstimonials-main-page`,
      },
      pageType: 'stresstimonials',
    }}
    id={id}
    className={`h-[40px] !pl-4 !pr-[6px] ${className}`}
  >
    <div className="flex w-full items-center justify-between gap-4">
      <span className="whitespace-nowrap">{label}</span>
      <div className="flex shrink-0 items-center justify-center rounded-[1.4px] bg-moss-white p-[6px]">
        <Icon name="arrow" className="size-2.5 text-moss-black" />
      </div>
    </div>
  </ButtonV2>
)
